import { qualifierToJson } from "./qualifierToJson.js";
export class QualifierModel {
    constructor() {
        this._qualifierModel = {};
    }
    toJson() {
        return qualifierToJson.apply(this);
    }
}
